module.exports = __webpack_public_path__ + "img/home-black-24px.4b7a41f1.svg";